export default function Confirmation() {
    return <div>Confirmation</div>;
}
